import { render, staticRenderFns } from "./AddBillItem.vue?vue&type=template&id=163e6ddf"
import script from "./AddBillItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBillItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports